module.exports = __webpack_public_path__ + "img/35.7c28341e.jpg";